import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import { GridLogicOperator } from '@mui/x-data-grid-premium';

var convertToDatagridSortType = function convertToDatagridSortType(sortResponse) {
  return sortResponse.reduce(function (acc, item) {
    var _a;
    var sortParam = (_a = item.sort) === null || _a === undefined ? undefined : _a.toUpperCase();
    if (sortParam === 'ASC' || sortParam === 'DESC') {
      return [].concat(_toConsumableArray(acc), [_defineProperty({}, item.field, sortParam)]);
    }
    return _toConsumableArray(acc);
  }, []);
};
var getDefaultFilterModel = function getDefaultFilterModel(field) {
  return {
    field: field,
    value: [],
    operator: GridLogicOperator.And
  };
};
var MAP_SIZE_NAMES_TO_HEIGHT = {
  small: 28,
  medium: 36,
  large: 44,
  'x-large': 56
};
function getSelectValueOptions(column, additionalParams) {
  if (!column) {
    return undefined;
  }
  return typeof column.valueOptions === 'function' ? column.valueOptions(Object.assign({
    field: column.field
  }, additionalParams)) : column.valueOptions;
}
function getTableRowHeightVariant(height) {
  if (height >= 56) return 'large';
  if (height >= 44) return 'medium';
  return 'small';
}
var isSortNativeType = function isSortNativeType(sortType) {
  return ['string', 'dateTime', 'date', 'number', 'singleSelect'].includes(sortType);
};
var convertGridNativeColTypeToSortNativeType = function convertGridNativeColTypeToSortNativeType(type) {
  if (type && isSortNativeType(type)) {
    return type;
  }
  return 'string';
};

export { MAP_SIZE_NAMES_TO_HEIGHT, convertGridNativeColTypeToSortNativeType, convertToDatagridSortType, getDefaultFilterModel, getSelectValueOptions, getTableRowHeightVariant };
